import { useCallback, useState } from 'react';
import { CustomButton } from '../../../../components/CustomButton';
import RModal from '../../../../components/Rsuite/Modal';
import { CustomInput } from '../../../../components/CustomInput';
import { Label } from '../../../../components/Label';
import api from '../../../../services/api';
import { toastSuccess, toastError } from '../../../../toasts';

const InsertAssasApiKey = ({ open, onClose, id_empresa }) => {
  const [token, setToken] = useState();

  const handleSubmit = useCallback(async () => {
    await api.patch(`/configuracao/insertKeyAsaas/${id_empresa}`, {
      apiKey: token
    })
    .then(() => {
      toastSuccess('Chave inserida', 'Sucesso');
      onClose();
    }).catch(() => {
      toastError('Não foi possivel salvar a chave da API');
    })
  },[id_empresa, onClose, token])

  return(
    <RModal
    title={"Inserir chave API"}
    open={open}
    onClose={onClose}
    footer={
      <>
        <CustomButton appearance="default" onClick={onClose}>
          Fechar
        </CustomButton>
        <CustomButton
          appearance="primary"
          onClick={handleSubmit}
        >
          Salvar
        </CustomButton>
      </>
    }
  >
    <Label>Chave da API</Label>
    <CustomInput
      style={{ minWidth: '650px' }}
      placeholder="***************************************************"
      value={token}
      onChange={setToken}
    />
  </RModal>
  )
}

export default InsertAssasApiKey;
